// externals
import type { MouseEventHandler } from 'react';
import styled from 'styled-components';

// interstate components
import { Action } from '@interstate/components/Action';
import { ArrowPathIcon } from '@interstate/components/Icons/ArrowPathIcon';

import { useRollToPayment } from './useRollToPayment';

const StyledAction = styled(Action)`
    && {
        padding: 0;
    }
`;

export const ROLL_TO_LABEL = 'Roll-To';

export const OpenRollToPaymentSlideOutButton = () => {
    const { isAvailable, isDisabled, toggle } = useRollToPayment();

    const handleToggleSlideOut: MouseEventHandler<HTMLAnchorElement> = (event): void => {
        event.stopPropagation();
        toggle();
    };

    if (!isAvailable) return null;

    return (
        <StyledAction
            actionIcon={{ icon: <ArrowPathIcon />, start: true }}
            id="roll-to-payment"
            data-testid="roll-to-payment"
            onClick={handleToggleSlideOut}
            size="md"
            sx={{ ml: '1rem' }}
            disabled={isDisabled}
        >
            {<span>{ROLL_TO_LABEL}</span>}
        </StyledAction>
    );
};
